'use client';

import { cn } from '@zealot/ui/lib/utils';
import type * as React from 'react';

type FileUploadErrorProps = React.ComponentProps<'p'>;

const FileUploadError = ({ className, children, ...props }: FileUploadErrorProps) => {
  if (!children) return null;

  return (
    <p data-slot="file-upload-error" role="alert" className={cn('text-destructive text-sm', className)} {...props}>
      {children}
    </p>
  );
};

export { FileUploadError };
